<script setup lang="ts">
import {ModelList} from '@jantm/model-core'
import Dashboard from "@/components/WiserDashboardComponent.vue";
import {ref} from "vue";
import type {StudentFilter} from "@/types/Wiser/student.ts";
import StudentFilterForm from "@/views/Wiser/StudentFilterForm.vue";
const modelFilter = ref<StudentFilter>({page: '1', perPage: '25'});
</script>

<template>
  <Dashboard />
  <div class="container">
    <StudentFilterForm v-model="modelFilter" />
    <ModelList class="model-list model-list-student" model="Student" :filter="modelFilter" />
  </div>
</template>

<style scoped></style>
